import { IPagedQuery, IPagedQueryS } from '../components/paginate';
import * as actionTypeProfile from '../action/profile';
import { UploadRelationType } from '../enums/UploadRelationType';

export interface IPageProps {
    history?: any;
    location?: any;
    match?: any;
    dispatch?: any;
}

export interface IPersonelFileView {
    fileId: string;
    fileName: string;
    contentType: string;
    filePath: string;
    size: number;
    activityId: string;
    activityName: string;
    parentCourseId: string;
    week: string;
    createdDate: string;
    uploadRelationType: UploadRelationType;
    fullName: string | null;
}

export interface IPersonelFileListPageProps extends IPageProps {
    results?: IPersonelFileView[];
    filters?: IPagedQuery;
    coursePageClassId?: string;
    userPreferences?: actionTypeProfile.IPreference[];
    userType?: any;
}

export interface IPersonelFileListPageState {
    filters: IPagedQueryS;
    model: IPersonelFileView;
    all_ids: Array<any>;
    selected_ids: Array<any>;
    goToStorageManagementPage: boolean;
    filterInitialValues: any;
    unselected_ids?: Array<any>;
    loading: boolean
}

export const PersonelFileInitialValues: IPersonelFileView = {
    fileId: '',
    fileName: '',
    contentType: '',
    filePath: '',
    size: 0,
    activityId: '',
    activityName: '',
    parentCourseId: '',
    week: '',
    createdDate: '',
    uploadRelationType: 0,
    fullName: ''
};

export const FilterInitialValues: IPagedQueryS = {
    orderBy: '',
    page: 1,
    take: 10,
    query: '',
    skip: 0,
    total: -1
};